import Toast from 'react-native-toast-message';
import { Flex, Typography } from '@banhala/ui-kit';
import { bridge } from '../../utils';

type BookmarkOutfitToastParams = {
  // 응답으로 받은 '저장한 코디' deeplink. null이면 보러가기 CTA 미노출.
  deeplink: string | null;
  screen: string;
  bottomOffset?: number;
  loggingAnalytics?: Record<string, unknown>;
  openDeeplink: (link: string) => void;
};

export const bookmarkOutfitToast = ({
  deeplink,
  screen,
  bottomOffset,
  loggingAnalytics,
  openDeeplink,
}: BookmarkOutfitToastParams) => {
  Toast.show({
    type: 'success',
    bottomOffset,
    position: 'bottom',
    props: {
      customText: (
        <Flex.Row
          padding={{ vertical: 12 }}
          width="100%"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography type="body2" color="content_always_white">
            {"'저장한 코디'에 추가했어요"}
          </Typography>
          {deeplink != null && (
            <Flex.Column
              onPress={() => {
                bridge.logAnalyticsEvent({
                  name: 'CLICK_MY_LIKE_STYLE',
                  analytics: {
                    SCREEN: screen,
                    LANDING_FROM: 'TOAST',
                    ...loggingAnalytics,
                  },
                });
                openDeeplink(deeplink);
              }}
              hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
            >
              <Typography color="content_blue_primary">보러가기</Typography>
            </Flex.Column>
          )}
        </Flex.Row>
      ),
    },
  });
};
